<template>
  <div class="my-5 mx-4 px-3">
    <!-- <h2 >Add new Exhibition </h2> -->
    <v-flex xs4 sm4 md4 mb-3> </v-flex>
    <v-stepper v-model="e1" class="elevation-1">
      <v-stepper-header>
        <v-stepper-step :complete="e1 > 1" step="1">Basic </v-stepper-step>
        <v-divider></v-divider>
        <v-stepper-step :complete="e1 > 2" step="2"> Artworks</v-stepper-step>
        <v-divider></v-divider>
        <v-stepper-step step="3">Summary</v-stepper-step>
      </v-stepper-header>
      <v-progress-linear
        indeterminate
        class="mt-0 pt-0"
        height="2"
        v-if="progress"
      ></v-progress-linear>

      <v-stepper-items>
        <v-stepper-content step="1">
          <v-card class="mb-3 elevation-0">
            <v-form @submit.prevent ref="form">
              <!-- <v-card class="px-3 pt-4 mt-4 elevation-0 editBG"> -->
              <v-container grid-list-md fluid>
                <v-layout row wrap>
                  <!-- <v-flex style="background-color:#292929; color: #eee;" class="px-3 py-1 my-2 elevation-0 xs12"> 
                      <h3 class="font-weight-bold subtitle xs12 flex"> Basic </h3>
                    </v-flex> -->

                  <v-flex xs12 class="px-4">
                    <v-text-field
                      v-model="exhibition.title"
                      label="Title"
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs12 class="px-4">
                    <v-autocomplete
                      label="Institution"
                      :items="institutions"
                      v-model="exhibition.institution_id"
                      item-value="id"
                      item-text="name"
                    ></v-autocomplete>
                    {{ exhibition.institution }}
                    <!-- <v-text-field
                      v-model="exhibition.institution"
                      label="Institution"
                    ></v-text-field> -->
                  </v-flex>

                  <v-flex xs12 sm6 class="px-4">
                    <v-text-field
                      v-model="exhibition.city"
                      label="City"
                    ></v-text-field>
                  </v-flex>

                  <v-flex xs12 sm6 class="px-4">
                    <v-autocomplete
                      :items="this.countries"
                      v-model="exhibition.country"
                      label="Country"
                    ></v-autocomplete>
                  </v-flex>

                  <v-flex xs12 sm4 md2 lg2 class="pl-4 pr-3">
                    <v-text-field
                      v-model="exhibition.duration_start_year"
                      label="Start Year"
                      placeholder="XXXX"
                      type="number"
                      :maxlength="4"
                      mask="####"
                      min="1800"
                      max="2030"
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs6 sm4 md2 lg2 pl-4 pr-3>
                    <v-text-field
                      v-model="exhibition.duration_start_month"
                      label="Month"
                      placeholder="XX"
                      type="number"
                      mask="##"
                      max="12"
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs6 sm4 md2 lg2 class="pl-4 pr-4">
                    <v-text-field
                      v-model="exhibition.duration_start_day"
                      label="Day"
                      placeholder="XX"
                      type="number"
                      mask="##"
                      max="31"
                    ></v-text-field>
                  </v-flex>

                  <v-flex xs12 sm4 md2 lg2 class="px-4">
                    <v-text-field
                      v-model="exhibition.duration_end_year"
                      label="End Year"
                      placeholder="XXXX"
                      type="number"
                      mask="####"
                      min="1800"
                      max="2030"
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs6 sm4 md2 lg2 pl-4 pr-3>
                    <v-text-field
                      v-model="exhibition.duration_end_month"
                      label="Month"
                      placeholder="XX"
                      type="number"
                      mask="##"
                      max="12"
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs6 sm4 md2 lg2 pl-4 pr-4>
                    <v-text-field
                      v-model="exhibition.duration_end_day"
                      label="Day"
                      placeholder="XX"
                      type="number"
                      mask="##"
                      max="31"
                    ></v-text-field>
                  </v-flex>

                  <v-flex xs12 sm6 md6 class="px-4 pt-4 mt-2">
                    <v-btn-toggle v-model="exhibition.show_type">
                      <v-btn
                        small
                        flat
                        key="group"
                        class="px-2"
                        input-value="2"
                        value="2"
                      >
                        <span> Group Show </span>
                      </v-btn>
                      <v-btn
                        small
                        flat
                        key="solo"
                        class="px-2"
                        input-value="1"
                        value="1"
                      >
                        <span> Solo Show </span>
                      </v-btn>
                    </v-btn-toggle>
                  </v-flex>

                  <!-- <v-flex xs12 sm6 md6 class='px-5 pt-3'>
                      <v-radio-group v-model="exhibition.show_type" row>
                        <v-radio label="Group Show" value="2" class='pr-5'></v-radio>
                        <v-radio label="Solo Show" value="1"></v-radio>
                      </v-radio-group>
                    </v-flex> -->

                  <v-flex xs12 sm6 md6 pt-3 class="px-5">
                    <v-switch
                      v-model="exhibition.loan"
                      label="Loan "
                      value="1"
                      color="black"
                    ></v-switch>
                  </v-flex>

                  <v-flex xs12 sm12 md12 px-4>
                    <v-textarea
                      v-model="exhibition.admin_note"
                      label="Note"
                      auto-grow
                      clearable
                      rows="1"
                    ></v-textarea>
                  </v-flex>

                  <v-flex
                    style="background-color:#292929; color: #eee;"
                    class="px-3 py-0 my-3 elevation-0 xs12"
                  >
                    <h3 class="font-weight-bold subtitle xs12 flex">
                      Public Website
                    </h3>
                  </v-flex>

                  <v-flex xs12 class="px-4">
                    <v-text-field
                      v-model="exhibition.link_from_list"
                      label="Link from list"
                    ></v-text-field>
                  </v-flex>

                  <v-flex xs12 class="px-4">
                    <v-checkbox
                      v-model="showInPublicWebsiteArtworkDetailPage"
                      label="Show in public website artwork's detail page"
                      color="black"
                    ></v-checkbox>
                  </v-flex>
                  <!-- <v-flex xs12 px-4>
                      <v-autocomplete
                        v-model="exhibition.artworks"
                        :items="artworks"
                        label="Artworks" item-text="title" item-value="id" multiple chips
                      ></v-autocomplete>
                    </v-flex> -->

                  <v-layout align-center justify-end mt-5>
                    <v-btn
                      color="primary"
                      @click="saveExhibition()"
                      :disabled="valid == ''"
                      >SAVE</v-btn
                    >
                    <!-- <v-btn :disabled="!approved" color="primary" @click.native="e1 = 2">Next</v-btn> -->
                    <v-btn @click="$router.go(-1)" flat>Cancel</v-btn>
                    <!-- <v-btn color="black" outline @click="$router.go(-1)">CANCEL</v-btn> -->
                  </v-layout>
                  <!-- <v-layout align-center justify-end mr-3>
                      <v-btn color="red" outline @click="deleteExhibition()">delete</v-btn>
                    </v-layout> -->
                </v-layout>
              </v-container>
              <!-- </v-card> -->
            </v-form>
          </v-card>
        </v-stepper-content>

        <v-stepper-content step="2">
          <v-card color="grey lighten-4" class="mb-5 pb-1">
            <!-- <v-card-title>Artwork Details</v-card-title> -->

            <v-container fluid>
              <v-layout row wrap>
                <v-flex xs12 sm12>
                  <!-- @input="getArwork(temp_artwork)" -->
                  <v-autocomplete
                    v-model="exhibition_artworks_ori"
                    multiple
                    open-on-clear
                    auto-select-first
                    clearable
                    hide-details
                    :items="artworks"
                    :item-text="
                      item =>
                        item.title +
                        ', ' +
                        item.accession_number +
                        ', ' +
                        item.name
                    "
                    label="Select Artworks to add to this Exhibition."
                    item-value="id"
                    menu-props='{"closeOnClick":true, "closeOnContentClick":false, "openOnClick":false, "maxHeight":600}'
                  >
                    <!-- prepend-icon="filter_list" -->
                    <!-- <template v-slot:item="data">
                      <div
                        :key="data.item.id"
                        :selected="data.selected"
                        :disabled="data.disabled"
                        @input="data.parent.selectItem(data.item)"
                      >
                      <v-checkbox value="data.item.selected"></v-checkbox>
                        {{ data.item.title }}
                      </div>
                    </template> -->
                    <template v-slot:selection="data">
                      <v-chip
                        :selected="data.selected"
                        close
                        @input="remove(data.item)"
                      >
                        <strong v-html="data.item.title"></strong>&nbsp;
                        <span>{{ data.item.accession_number }} </span>&nbsp;
                        <strong
                          v-html="
                            data.item.artist
                              ? data.item.artist.name
                              : data.item.name
                          "
                        ></strong>
                      </v-chip>
                    </template>
                  </v-autocomplete>

                  <!-- <v-autocomplete item-text="title" item-value="id" label="Select Artwork to add to this Exhibition."
                    :items="artworks"
                    v-model="temp_artwork"
                    @input="getArwork(temp_artwork)"
                  ></v-autocomplete> -->
                </v-flex>
              </v-layout>
            </v-container>

            <!-- <v-progress-circular class="ml-5 pl-5 mb-5" v-if="progress"
              :size="70"
              :width="5"
              color="grey"
              indeterminate
            ></v-progress-circular> -->

            <!-- <div v-if="processedArtwork" class="ml-3 pb-3">
              <v-card-title primary-title class="pt-0 mt-0">
                <div>
                  <h3 class="headline mb-0">{{processedArtwork.title}}</h3>
                  <div>
                    Artist: {{processedArtwork.full_name}} <br>
                    Accession Number: {{processedArtwork.accession_number}} <br>
                    Production Year: {{processedArtwork.production_date_new}}<br>
                  </div>
                </div>
              </v-card-title>
              <v-card-actions> 
                <v-btn color="primary" @click.native="addArtwork(processedArtwork.id)">Add artwork to Exhibition</v-btn>
              </v-card-actions>
            </div> -->

            <div title class="pt-0 ml-4 mb-2 mt-0" v-if="exhibition_artworks">
              <h3>Artworks in Exhibition ({{ exhibition_artworks.length }})</h3>
            </div>

            <v-list two-line class="mx-4 mb-4">
              <!-- <template v-for="(item, index) in exhibition_artworks"> -->
              <!-- <v-divider :key="index" ></v-divider> -->
              <v-list-tile :key="item.id" v-for="item in exhibition_artworks">
                <v-list-tile-avatar>
                  <img
                    v-if="item.top_photo_id > 0"
                    v-bind:src="
                      `${                                                                         $globals.fileserver}/data/artwork/${item.id}/${item.top_photo_id}_th_big.jpg`
                    "
                  />
                </v-list-tile-avatar>
                <v-list-tile-content>
                  <v-list-tile-title
                    v-html="`${item.title} (${item.production_date_new})`"
                  ></v-list-tile-title>
                  <v-list-tile-sub-title
                    v-html="item.full_name"
                  ></v-list-tile-sub-title>
                </v-list-tile-content>
              </v-list-tile>
              <!-- </template> -->
            </v-list>
          </v-card>
          <v-btn color="primary" @click.native="e1 = 1"
            ><v-icon class="pr-2">mdi-arrow-left-bold-box</v-icon>Back to
            Basic</v-btn
          >
          <v-btn
            color="primary"
            :disabled="!valid"
            @click.native="updateExhibition"
            >Save and Continue</v-btn
          >
          <v-btn flat @click="$router.push('/exhibitions')"
            >Cancel & go to Exhibition List</v-btn
          >
        </v-stepper-content>

        <v-stepper-content step="3">
          <v-card
            color="grey lighten-4 elevation-0"
            class="mb-5 pl-3 pr-3 pb-3"
          >
            <v-flex xs12
              ><br />
              <h3 class="title mb-3">
                {{ exhibition.title }}
                <span v-if="exhibition.loan"> - (LOAN)</span>
                <span v-if="exhibition.show_type == 1"> - (SOLO)</span>
                <span v-if="exhibition.show_type == 2"> - (GROUP)</span>
              </h3>
              <!-- <v-btn color="primary" @click.native="pdf">Download PDF </v-btn>               -->

              <table class="mb-0 main">
                <tr>
                  <td>Start Date:</td>
                  <td>{{ start_date }}</td>
                </tr>
                <tr>
                  <td>End Date:</td>
                  <td>{{ end_date }}</td>
                </tr>
                <tr>
                  <td>Institution:</td>
                  <td>{{ exhibition.institution }}</td>
                </tr>
                <tr>
                  <td>City:</td>
                  <td>{{ exhibition.city }}</td>
                </tr>
                <tr>
                  <td>Country:</td>
                  <td>{{ exhibition.country }}</td>
                </tr>
                <tr>
                  <td>Note:</td>
                  <td>{{ exhibition.admin_note }}</td>
                </tr>
                <tr>
                  <td style="height: 3em; vertical-align: bottom;" colspan="2">
                    Artworks:
                  </td>
                </tr>
              </table>

              <!-- <table class="mb-5">
                <tr>
                  <td> -->
              <v-list two-line class="mx-0 mb-2">
                <v-list-tile :key="item.id" v-for="item in exhibition.artworks">
                  <v-list-tile-avatar>
                    <img
                      v-if="item.top_photo_id > 0"
                      v-bind:src="
                        `${this.$globals.apiserver}/data/artwork/${item.id}/${item.top_photo_id}_th_big.jpg`
                      "
                    />
                  </v-list-tile-avatar>
                  <v-list-tile-content>
                    <v-list-tile-title
                      v-html="`${item.title} (${item.production_date_new})`"
                    ></v-list-tile-title>
                    <v-list-tile-sub-title
                      v-html="item.full_name"
                    ></v-list-tile-sub-title>
                  </v-list-tile-content>
                </v-list-tile>
              </v-list>
              <!-- </td>
                </tr>
              </table> -->
              <v-btn color="primary" @click.native="e1 = 2">
                <v-icon class="mr-2">mdi-arrow-left-bold-box</v-icon>
                Back to Artwork Selection
              </v-btn>
              <v-btn flat @click="$router.push('/exhibitions')"
                >go to Exhibition List</v-btn
              >
            </v-flex>
          </v-card>
          <v-btn
            color="primary"
            @click="
              $router.push({
                name: 'EditExhibition',
                params: { id: exhibition.id, exhibition: exhibition },
                path: `/exhibitions/edit/${exhibition.id}`
              })
            "
          >
            Go to Exhibition Edit Page
          </v-btn>
        </v-stepper-content>
      </v-stepper-items>
    </v-stepper>
  </div>
</template>

<script>
import axios from '@/utils/apiClient'
import constants from '@/data/constants'
export default {
  data() {
    return {
      progress: false,
      constants: constants,
      countries: constants.COUNTRIES,
      temp_artwork: '',
      exhibition_artworks_ori: [],
      // fields: fields,
      exhibition: {
        id: '',
        artworks: [],
        artwork_ids: [],
        title: '',
        institution: '',
        institution_id: '',
        city: '',
        duration_start_year: '',
        duration_start_month: '',
        duration_start_day: '',
        country: '',
        duration_end_year: '',
        duration_end_month: '',
        duration_end_day: '',
        show_type: [],
        admin_note: '',
        loan: '',
        link_from_list: '',
        do_not_link_from_artworks2: false
      },
      report: {
        date: ''
      },
      success: false,
      menu: false,
      modal: false,
      menu2: false,
      e1: 0,
      autosave: true,
      result: '',
      result_a: ''
    }
  },
  methods: {
    // format_date (date,format="YYYY-MM-DD") {
    //   var moment = require('moment')
    //   var ndate = new Date(date)
    //   return moment(ndate).format(format)
    // },
    addArtwork(id) {
      var a = this.$store.state.artworks.find(a => a.id == id)
      if (!this.exhibition_artworks.includes(a)) {
        this.exhibition_artworks.push(a)
      }
      this.temp_artwork = ''
      this.result_a = ''
    },
    getArwork(id) {
      this.progress = true
      let url = `${this.$globals.apiserver}/artworks/${id}.json`
      axios
        .get(url)
        .then(response => {
          this.result_a = response.data
          this.progress = false
        })
        .catch(error => {
          console.log(error)
        })
      this.progress = false
    },
    saveExhibition() {
      this.progress = true
      this.exhibition.duration_end = this.exhibition_duration_end
      // this.format_date(new Date(this.exhibition.duration_end_year, this.exhibition.duration_end_month-1, this.exhibition.duration_end_day),'YYYY-MM-DD');
      this.exhibition.duration_start = this.exhibition_duration_start
      // this.format_date(new Date(this.exhibition.duration_start_year, this.exhibition.duration_start_month-1, this.exhibition.duration_start_day),'YYYY-MM-DD');
      let url = `${this.$globals.apiserver}/exhibitions.json`
      axios
        .post(url, this.exhibition)
        .then(response => {
          this.result = response.data
          this.exhibition = response.data
          this.$store.dispatch('addExhibition', Object.assign({},response.data))
          this.progress = false
          this.e1 = 2
        })
        .catch(error => {
          console.log(error)
        })
    },
    updateExhibition() {
      this.progress = true
      delete this.exhibition.exhibition_artworks
      this.exhibition.duration_end = this.exhibition_duration_end
      // this.format_date(new Date(this.exhibition.duration_end_year, this.exhibition.duration_end_month-1, this.exhibition.duration_end_day),'YYYY-MM-DD');
      this.exhibition.duration_start = this.exhibition_duration_start
      // this.format_date(new Date(this.exhibition.duration_start_year, this.exhibition.duration_start_month-1, this.exhibition.duration_start_day),'YYYY-MM-DD');
      this.exhibition.artwork_ids = this.exhibition_artworks.map(ea => ea.id)
      this.exhibition.artworks = this.exhibition.artwork_ids
      delete this.exhibition.artworks
      // console.log(this.exhibition)
      let url = `${this.$globals.apiserver}/exhibitions/${this.exhibition.id}.json`
      axios
        .put(url, { exhibition: this.exhibition })
        .then(response => {
          this.result = response.data
          this.exhibition = response.data
          // this.$store.dispatch('updateExhibition',response.data)
          this.progress = false
          this.e1 = 3
        })
        .catch(error => {
          console.log(error)
        })
      this.progress = false
    },
    clear() {
      this.$refs.form.reset()
    },
    pdf() {
      // download PDF
    }
  },
  computed: {
    institutions() {
      return this.$store.state.contacts.filter(
        c => c.category == 'exhibition_institution'
      )
    },
    showInPublicWebsiteArtworkDetailPage: {
      get() {
        return ![true, 1, '1', 'true'].includes(
          this.exhibition.do_not_link_from_artworks2
        )
      },
      set(value) {
        this.exhibition.do_not_link_from_artworks2 = !Boolean(value)
      }
    },
    exhibition_artworks() {
      return this.exhibition_artworks_ori.map(ea =>
        this.$store.state.artworks.find(a => a.id == ea)
      )
    },
    exhibition_duration_end() {
      return `${this.exhibition.duration_end_year}-${this.exhibition.duration_end_month}-${this.exhibition.duration_end_day}`
    },
    exhibition_duration_start() {
      return `${this.exhibition.duration_start_year}-${this.exhibition.duration_start_month}-${this.exhibition.duration_start_day}`
    },
    start_date() {
      return `${this.exhibition.duration_start_year}. ${this.exhibition.duration_start_month}. ${this.exhibition.duration_start_day}`
    },
    end_date() {
      return `${this.exhibition.duration_end_year}. ${this.exhibition.duration_end_month}. ${this.exhibition.duration_end_day}`
    },
    valid() {
      return this.exhibition.title
    },
    processedArtwork() {
      let processedArtwork = this.result_a
      return processedArtwork
    },
    artworks() {
      return Object.assign([], this.$store.state.artworks)
    }
  }
}
</script>

<style scoped>
.main td {
  width: 140px;
  line-height: 2em;
  vertical-align: top;
}
</style>



// WEBPACK FOOTER //
// src/components/exhibitions/AddExhibition.vue